import { IItem, AbstractSourceEditableItem } from "../../../../domain/document/items";
import { Rectangle, Point, Size } from "../../../../domain/drawing";
import { ITypeDefinable, ISourceEditableItemBean } from "../beans/items";
import { IObjectTranslatable } from "./IObjectTranslatable";
import { RelationalActionTranslator } from "./RelationalActionTranslator";

export abstract class AbstractSourceEditableItemTranslator<T extends AbstractSourceEditableItem, TBean extends ISourceEditableItemBean> implements IObjectTranslatable {
  toItem(source: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = source as TBean;
    const result = this.createItem(bean);
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.isVisible = !!bean.isVisible;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.source = null; // sourceのアサインは別途relation解決時に行うが型判定できるようnullを設定しておく.
    return result;
  }

  protected abstract createItem(source: TBean): T;

  toBean(source: IItem): ITypeDefinable {
    const item = source as T;
    const result = this.createBean(item);
    result.uniqueKey = item.uniqueKey;
    result.id = item.id;
    result.sectionObjectUid = item.sectionObjectUid;
    result.isAdditional = item.isAdditional;
    result.isDeleted = item.isDeleted;
    result.x = item.geometry.rectangle.x;
    result.y = item.geometry.rectangle.y;
    result.width = item.geometry.rectangle.width;
    result.height = item.geometry.rectangle.height;
    result.isVisible = item.isVisible;
    result.printVisible = item.printBehavior.shouldPrint;
    result.previewVisible = item.printBehavior.shouldPreview;
    result.relationalItems = null;  // TODO:返却する必要ある？
    return result;
  }

  protected abstract createBean(source: T): TBean;
}
